export type * from './types.ts';
export { IDENTITY, apply, compose, invert, toSvg } from './affine.ts';
export {
  DEFAULT_FOCUS, DEFAULT_TRANSFORM, FREE_MAX_OFFSET, FREE_MIN_SCALE, MAX_SCALE, MIN_SCALE, centroid,
  coverPlacement, covers, fillZone, frameOutlines, limitTransform,
  partShift, placeImage, zoneFrame,
} from './placement.ts';
export { STRATEGIES, fillInOrder } from './assign.ts';
export { shapeOf, withShapes } from './shapes.ts';
export type { ZoneShapeOption, ZoneShapes } from './shapes.ts';
export type { AssignableImage, AssignmentStrategy } from './assign.ts';

import type { ProjectDocument, TemplateDocument } from './types.ts';
import { DEFAULT_TEXT } from './text.ts';

export const PROJECT_SCHEMA = 'foldmycard/project@1' as const;

/** A blank card on a given template: every zone empty, but the frames that start with words or a symbol. */
export function emptyProjectDocument(t: TemplateDocument): ProjectDocument {
  // frames that start with words (the fortune teller's numbers and fortunes) get them now, and
  // frames that start with a symbol (the square letter's heart and star) theirs
  const zones: ProjectDocument['zones'] = {};
  for (const z of t.zones) {
    if (z.defaultSymbol) zones[z.number] = { image: null, symbol: { ...z.defaultSymbol } };
    if (!z.defaultText) continue;
    zones[z.number] = {
      image: null,
      text: {
        content: z.defaultText.content, shape: DEFAULT_TEXT.shape, language: 'en',
        ...(z.defaultText.sizeMm ? { sizeMm: z.defaultText.sizeMm } : {}),
        ...(z.defaultText.bold ? { bold: true } : {}),
      },
    };
  }
  return {
    schema: PROJECT_SCHEMA,
    template: { id: t.templateId, paper: t.paper.slug, geometryHash: t.geometryHash },
    theme: 'full-color',
    zones,
  };
}
export {
  DEFAULT_TEXT, FONTS, MIN_TEXT_MM, RTL_LANGUAGES, codeSpot, isRtl, layoutText, noteShape, textShape, uprightZone,
} from './text.ts';
export type { CodeRequest, CodeSpot, FontKey, LaidLine, Measure, TextLayout, TextStyle } from './text.ts';
